// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1-Yt0","inner":"Footer_inner__yjZPL"};